module.exports = __webpack_public_path__ + "img/plus.89822d5e.svg";